import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-770cd79c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-search el-input__icon fas" }, null, -1))
const _hoisted_2 = ["title"]
const _hoisted_3 = ["title"]
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_page_header_component = _resolveComponent("page-header-component")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_container_info_component = _resolveComponent("container-info-component")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_container_form_component = _resolveComponent("container-form-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, null, {
      header: _withCtx(() => [
        _createVNode(_component_page_header_component, {
          title: _ctx.$t('label.containerList')
        }, {
          right: _withCtx(() => [
            _createVNode(_component_el_input, {
              class: "search",
              modelValue: _ctx.query,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.search()))
            }, {
              prefix: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: _ctx.containers,
          stripe: "",
          "row-class-name": _ctx.tableRowClassName
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: _ctx.$t('label.name'),
              width: "180"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (_ctx.openContainerInfoDialog(scope.row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.name), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "containerType.name",
              label: _ctx.$t('label.type'),
              align: "center",
              "header-align": "center"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.containerType.name ? scope.row.containerType.name : "-"), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "locality",
              label: _ctx.$t('label.locality'),
              align: "center",
              "header-align": "center"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.locality ? scope.row.locality : "-"), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "province",
              label: _ctx.$t('label.province'),
              align: "center",
              "header-align": "center"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.province ? scope.row.province : "-"), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "country",
              label: _ctx.$t('label.country'),
              align: "center",
              "header-align": "center"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.country ? scope.row.country : "-"), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "waterFlow",
              label: _ctx.$t('label.waterFlow'),
              align: "center",
              "header-align": "center"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.waterFlow ? scope.row.waterFlow : "-"), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "active",
              label: _ctx.$t('label.status'),
              align: "center",
              "header-align": "center"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_tag, {
                  type: scope.row.active ? 'success' : 'danger'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(scope.row.active ? "status.active" : "status.no-active")), 1)
                  ]),
                  _: 2
                }, 1032, ["type"])
              ]),
              _: 1
            }, 8, ["label"]),
            (_ctx.canWrite)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  fixed: "right",
                  label: _ctx.$t('label.operations'),
                  align: "center",
                  "header-align": "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_button, {
                      type: "default",
                      size: "small",
                      onClick: ($event: any) => (_ctx.openContainerFormDialog(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("em", {
                          class: "el-icon el-icon-edit fas",
                          title: _ctx.$t('btn.edit')
                        }, null, 8, _hoisted_2)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    (!scope.row.active)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "success",
                          size: "small",
                          onClick: ($event: any) => (_ctx.confirmActivateItem(scope.row))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("em", {
                              class: "el-icon el-icon-check fas",
                              title: _ctx.$t('btn.activate')
                            }, null, 8, _hoisted_3)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (scope.row.active)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "danger",
                          size: "small",
                          onClick: ($event: any) => (_ctx.confirmDeactivateItem(scope.row))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("em", {
                              class: "el-icon el-icon-times fas",
                              title: _ctx.$t('btn.deactivate')
                            }, null, 8, _hoisted_4)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data", "row-class-name"]),
        _createVNode(_component_el_pagination, {
          class: "app-table",
          layout: "total, sizes, prev, pager, next, jumper",
          currentPage: _ctx.currentPage,
          "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentPage) = $event)),
          "page-sizes": [10, 20, 50, 100],
          "page-size": _ctx.rowPerPage,
          total: _ctx.totalRows,
          onSizeChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changePaginationSize($event))),
          onCurrentChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changePaginationPage($event)))
        }, null, 8, ["currentPage", "page-size", "total"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showContainerInfo,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showContainerInfo) = $event)),
      "show-close": "",
      title: _ctx.containerSelected?.name,
      width: "50%",
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        (_ctx.containerSelected?.id !== undefined)
          ? (_openBlock(), _createBlock(_component_container_info_component, {
              key: 0,
              id: _ctx.containerSelected.id
            }, null, 8, ["id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showContainerForm,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showContainerForm) = $event)),
      title: _ctx.$t(_ctx.containerSelected?.id ? 'label.containerEdit' : 'label.containerNew'),
      width: "50%",
      "destroy-on-close": "",
      "custom-class": "app-form"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_el_button, {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeContainerDialog()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.saveContainer()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("btn.save")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_container_form_component, {
          ref: "containerForm",
          id: _ctx.containerSelected?.id
        }, null, 8, ["id"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}